/* ROVIAN LUXE — interacciones (sin dependencias) */
(function () {
  if (window.__lxInit) return; window.__lxInit = true;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var MX = { timeZone: 'America/Mexico_City' };

  /* ---------- Aparición suave ---------- */
  function reveal(root) {
    var els = $$('.lx-rv:not(.is-in)', root);
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Fechas de entrega (días hábiles, hora de CDMX) ---------- */
  function addBiz(d, n) { var x = new Date(d); var k = 0; while (k < n) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) k++; } return x; }
  function fmt(d) { return d.toLocaleDateString('es-MX', { weekday: 'short', day: 'numeric', month: 'short', timeZone: MX.timeZone }).replace('.', ''); }
  function eta(root) {
    $$('[data-lx-eta]', root).forEach(function (el) {
      var mn = +el.dataset.min || 3, mx = +el.dataset.max || 6, now = new Date();
      var a = $('[data-min]', el), b = $('[data-max]', el);
      if (a) a.textContent = fmt(addBiz(now, mn)); if (b) b.textContent = fmt(addBiz(now, mx));
    });
  }

  /* ---------- Galería: carrusel cuadrado + miniaturas + flechas ---------- */
  function gallery(root) {
    $$('[data-lx-gal]', root).forEach(function (g) {
      if (g.dataset.ok) return; g.dataset.ok = 1;
      var tr = $('.lxp-track', g), sl = $$('.lxp-slide', g), cnt = $('[data-lx-count]', g), th = $$('[data-lx-thumb]', g), pv = $('[data-lx-gprev]', g), nx = $('[data-lx-gnext]', g), wrap = $('.lxp-thumbs', g);
      if (!tr || sl.length < 2) return;
      function cur() { var w = sl[0].offsetWidth + 10; return Math.max(0, Math.min(sl.length - 1, Math.round(tr.scrollLeft / w))); }
      function go(i) { i = Math.max(0, Math.min(sl.length - 1, i)); tr.scrollTo({ left: i * (sl[0].offsetWidth + 10), behavior: 'smooth' }); }
      function upd() {
        var i = cur(); if (cnt) cnt.textContent = (i + 1) + ' / ' + sl.length;
        th.forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
        if (pv) pv.disabled = i === 0; if (nx) nx.disabled = i === sl.length - 1;
        var a = th[i]; if (a && wrap) { var l = a.offsetLeft - wrap.offsetLeft, r = l + a.offsetWidth; if (l < wrap.scrollLeft || r > wrap.scrollLeft + wrap.clientWidth) wrap.scrollTo({ left: l - 20, behavior: 'smooth' }); }
        sl.forEach(function (s, k) { var v = $('video', s); if (v) { if (k === i) v.play().catch(function () {}); else v.pause(); } });
      }
      th.forEach(function (b) { b.addEventListener('click', function () { go(+b.dataset.lxThumb); }); });
      if (pv) pv.addEventListener('click', function () { go(cur() - 1); });
      if (nx) nx.addEventListener('click', function () { go(cur() + 1); });
      var t; tr.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(upd, 60); }, { passive: true });
      window.addEventListener('resize', upd); upd();
      g.__goTo = function (src) { var k = sl.findIndex(function (s) { var im = $('img', s); return im && src && (im.currentSrc || im.src).split('?')[0] === src.split('?')[0]; }); if (k > -1) go(k); };
    });
  }

  /* ---------- Producto: opciones, carrito, barra fija ---------- */
  function money(c, tpl) { c = Math.round(+c); var p = Math.floor(c / 100), r = c % 100; return '$' + p.toLocaleString('en-US') + (r ? '.' + String(r).padStart(2, '0') : ''); }
  function product(root) {
    $$('[data-lx-product]', root).forEach(function (P) {
      if (P.dataset.ok) return; P.dataset.ok = 1;
      var opts = $$('[data-lx-opt]', P), btn = $('[data-lx-add]', P), price = $('[data-lx-price]', P), cmp = $('[data-lx-cmp]', P), msg = $('[data-lx-msg]', P);
      var st = $('[data-lx-sticky]', P) || $('[data-lx-sticky="' + P.id + '"]'), stP = st && $('[data-lx-sprice]', st), stB = st && $('[data-lx-sadd]', st), stImg = st && $('img', st);
      var state = { id: P.dataset.vid, qty: +P.dataset.qty || 1, p: P.dataset.price, c: P.dataset.cmp, img: '' };
      function apply(o) {
        opts.forEach(function (x) { x.classList.toggle('is-on', x === o); x.setAttribute('aria-checked', x === o ? 'true' : 'false'); });
        state = { id: o.dataset.id, qty: +o.dataset.qty || 1, p: o.dataset.p, c: o.dataset.c, img: o.dataset.img || '' };
        if (price) price.textContent = state.p; if (cmp) { cmp.textContent = state.c || ''; cmp.hidden = !state.c; } var pc = $('[data-lx-pct]', P); if (pc) { pc.textContent = o.dataset.pct || ''; pc.hidden = !o.dataset.pct; }
        $$('[data-lx-btnprice]', P).forEach(function (e) { e.textContent = state.p; });
        if (stP) stP.textContent = state.p; if (stImg && state.img) stImg.src = state.img;
      }
      opts.forEach(function (o) { o.addEventListener('click', function () { apply(o); }); });
      var pre = opts.find(function (o) { return o.classList.contains('is-on'); }) || opts[0]; if (pre) apply(pre);

      function add(e) {
        if (e) e.preventDefault();
        if (!state.id) return;
        var b = this; b.setAttribute('disabled', ''); b.setAttribute('aria-busy', 'true'); if (msg) msg.textContent = '';
        var drawer = document.querySelector('cart-drawer');
        var body = { items: [{ id: +state.id, quantity: state.qty }] };
        if (drawer && drawer.getSectionsToRender) { body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = window.location.pathname; }
        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status && res.status !== 200) { if (msg) msg.textContent = res.description || res.message || 'No se pudo agregar. Intenta de nuevo.'; return; }
            if (drawer && drawer.renderContents) { if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty'); drawer.renderContents(res); }
            else window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
          })
          .catch(function () { if (msg) msg.textContent = 'Ups, revisa tu conexión e intenta de nuevo.'; })
          .finally(function () { b.removeAttribute('disabled'); b.removeAttribute('aria-busy'); });
      }
      if (btn) btn.addEventListener('click', add);
      if (stB) stB.addEventListener('click', add);
      if (st && btn) {
        var tick = function () { var r = btn.getBoundingClientRect(); var foot = document.querySelector('footer, .lxft'); var fr = foot ? foot.getBoundingClientRect().top : 1e9; st.classList.toggle('is-on', r.bottom < 0 && fr > window.innerHeight * .9); };
        window.addEventListener('scroll', function () { window.requestAnimationFrame(tick); }, { passive: true }); tick();
      }
    });
  }

  /* ---------- Antes y después ---------- */
  function compare(root) {
    $$('[data-lx-ba]', root).forEach(function (W) {
      if (W.dataset.ok) return; W.dataset.ok = 1;
      var tabs = $$('[data-lx-tab]', W), panes = $$('.lxa-cmp', W);
      tabs.forEach(function (t, i) { t.addEventListener('click', function () { tabs.forEach(function (x, k) { x.classList.toggle('is-on', k === i); }); panes.forEach(function (p, k) { p.hidden = k !== i; }); }); });
      panes.forEach(function (c) {
        var drag = false;
        function set(x) { var r = c.getBoundingClientRect(); var p = Math.max(2, Math.min(98, (x - r.left) / r.width * 100)); c.style.setProperty('--x', p + '%'); }
        c.addEventListener('pointerdown', function (e) { drag = true; c.setPointerCapture && c.setPointerCapture(e.pointerId); set(e.clientX); });
        c.addEventListener('pointermove', function (e) { if (drag) set(e.clientX); });
        ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) { c.addEventListener(ev, function () { drag = false; }); });
        c.addEventListener('keydown', function (e) { var v = parseFloat(getComputedStyle(c).getPropertyValue('--x')) || 50; if (e.key === 'ArrowLeft') c.style.setProperty('--x', Math.max(2, v - 5) + '%'); if (e.key === 'ArrowRight') c.style.setProperty('--x', Math.min(98, v + 5) + '%'); });
      });
    });
  }

  /* ---------- Comunidad: flechas + videos ---------- */
  function ugc(root) {
    $$('[data-lx-ugc]', root).forEach(function (U) {
      if (U.dataset.ok) return; U.dataset.ok = 1;
      var tr = $('.lxu-track', U), pv = $('[data-lx-prev]', U), nx = $('[data-lx-next]', U);
      function step(d) { var c = $('.lxu-card', tr); if (!c) return; tr.scrollBy({ left: d * (c.offsetWidth + 12), behavior: 'smooth' }); }
      if (pv) pv.addEventListener('click', function () { step(-1); }); if (nx) nx.addEventListener('click', function () { step(1); });
      var vids = $$('video', U);
      if ('IntersectionObserver' in window) { var io = new IntersectionObserver(function (es) { es.forEach(function (e) { var v = e.target; if (e.isIntersecting) v.play().catch(function () {}); else v.pause(); }); }, { threshold: .4 }); vids.forEach(function (v) { v.muted = true; io.observe(v); }); }
      $$('[data-lx-snd]', U).forEach(function (b) { b.addEventListener('click', function () { var v = $('video', b.parentNode); if (!v) return; v.muted = !v.muted; if (!v.muted) v.play().catch(function () {}); b.innerHTML = v.muted ? b.dataset.off : b.dataset.on; }); });
    });
  }

  /* ---------- Videos sueltos (portada / bloques) ---------- */
  function autoVideos(root) {
    $$('video[data-lx-auto], [data-lx-autowrap] video', root).forEach(function (v) {
      if (v.dataset.ok) return; v.dataset.ok = 1; v.muted = true; v.playsInline = true;
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) v.play().catch(function () {}); else v.pause(); }); }, { threshold: .25 }).observe(v); else v.play().catch(function () {});
    });
  }

  /* ---------- Barra de anuncios ---------- */
  function bar(root) {
    $$('[data-lx-bar]', root).forEach(function (B) {
      if (B.dataset.ok) return; B.dataset.ok = 1;
      var ms = $$('.lxb-m', B); if (!ms.length) return; var i = 0, d = (+B.dataset.delay || 4) * 1000;
      function show(n) { i = (n + ms.length) % ms.length; ms.forEach(function (m, k) { m.classList.toggle('is-on', k === i); }); }
      show(0); if (ms.length > 1) setInterval(function () { show(i + 1); }, d);
    });
  }

  /* ---------- Header: menú móvil ---------- */
  function header(root) {
    $$('[data-lx-header]', root).forEach(function (H) {
      if (H.dataset.ok) return; H.dataset.ok = 1;
      var panel = $('.lxh-panel', H);
      function open(v) { if (!panel) return; panel.classList.toggle('is-open', v); document.documentElement.style.overflow = v ? 'hidden' : ''; }
      $$('[data-lx-open]', H).forEach(function (b) { b.addEventListener('click', function () { open(true); }); });
      $$('[data-lx-close]', H).forEach(function (b) { b.addEventListener('click', function () { open(false); }); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') open(false); });
    });
  }

  /* ---------- Botones que suben a la compra ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-lx-top]'); if (!a) return;
    var t = document.querySelector('[data-lx-product] .lxp-opts') || document.querySelector('[data-lx-product]'); if (!t) return;
    e.preventDefault(); window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 90, behavior: 'smooth' });
  });

  function init(root) { reveal(root); eta(root); gallery(root); product(root); compare(root); ugc(root); autoVideos(root); bar(root); header(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); $$('.lx-rv', e.target).forEach(function (x) { x.classList.add('is-in'); }); });
})();